import IniciadorEjecucionFormView from 'src/components/views/EscritosLexnet/components/IniciadorEjecucion/IniciadorEjecucionFormView'
import SubmitForm from 'src/components/views/EscritosLexnet/components/shared/components/SubmitForm'

type IniciadorEjecucionPropsTyps = {
  section: string
}

function IniciadorEjecucion({ section }: IniciadorEjecucionPropsTyps): JSX.Element {
  return (
    <SubmitForm>
      <IniciadorEjecucionFormView section={section} />
    </SubmitForm>
  )
}

export default IniciadorEjecucion
